// 3rd-party
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  MenuItem,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Add } from "@mui/icons-material";

// Components
import Spinner from "../../components/spinner/Spinner";

// Services
import { logout } from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// Config
import { appConfig } from "../../config/appConfig";

// AssetComponents
import edit from "../../assets/edit.svg";
import delete1 from "../../assets/delete.svg";
import add from "../../assets/add.svg";
import approve from "../../assets/approve.svg";
import visiable from "../../assets/visiable.svg";
import plusaccor from "../../assets/accordian/plus-accordian.svg";
import minusaccor from "../../assets/accordian/minus-accordian.svg";

// Styles
import "../StateData/StateData.scss";
import StateImageFormDialog from "./StateImageFormDialog";

interface State {
  id: number;
  name: string;
}
type AdminEntry = {
  [x: string]: any;
  id: number;
  state: string;
  stateName: string;
  imagename: string;
  imageUrls: string | string[];
  isActive: boolean;
  isIconActive: boolean;
  status: string;
};
const StateImage = () => {
  const [dataList, setDataList] = useState<AdminEntry[]>([]);
  const [filteredDataList, setFilteredDataList] = useState<AdminEntry[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [states, setStates] = useState<State[]>([]);
  const [expandedState, setExpandedState] = useState<string | false>(false);
  const [formData, setFormData] = useState<AdminEntry>({
    id: 0,
    state: "",
    imagename: "",
    imageUrls: [],
    isActive: false,
    status: "",
    stateName: "",
    isIconActive: false,
  });

  const [page, setPage] = useState(0);
  const rowsPerPage = 5;
  const [role, setRole] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [statefilter, setstatefilter] = useState("");

  const groupedByState = filteredDataList.reduce(
    (acc, item) => {
      if (!acc[item.stateName]) {
        acc[item.stateName] = [];
      }
      acc[item.stateName].push(item);
      return acc;
    },
    {} as { [key: string]: typeof dataList },
  );

  // Sort state keys alphabetically
  const sortedStateKeys = Object.keys(groupedByState).sort((a, b) =>
    a.localeCompare(b),
  );

  useEffect(() => {
    const filtered = statefilter
      ? dataList.filter((item) => item.stateName === statefilter)
      : dataList;

    setFilteredDataList(filtered);
  }, [statefilter, dataList]);

  useEffect(() => {
    const storedRole = getStorageItemLocal("role");

    if (storedRole) setRole(JSON.parse(storedRole));
  }, []);

  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: AdminEntry[] = JSON.parse(savedData);
      setDataList(parsedData);
      setFilteredDataList(parsedData);

      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const imageUrls =
          typeof selectedEntry.imageUrls === "string"
            ? selectedEntry.imageUrls.split(",")
            : Array.isArray(selectedEntry.imageUrls)
              ? selectedEntry.imageUrls
              : [];
        setFormData({
          ...selectedEntry,
          imageUrls,
        });
      }
    }
  }, [editingIndex, dataList]);
  //Fetch Categories and states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const tokenString = getStorageItemLocal("token");
        const token = tokenString ? JSON.parse(tokenString) : null;
        const response = await fetch(
          `${appConfig.serviceUrls.getAdminEntries}/states`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.status === 401) {
          logout(navigate);
          <Button onClick={() => logout(navigate)}>Logout</Button>;
          return;
        }
        if (!response.ok) throw new Error("Failed to fetch states");
        const data = await response.json();
        setStates(data);
      } catch (error) {
        console.error("Error fetching states", error);
      }
    };
    //call the fetch functions
    fetchStates();
  }, []);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(
        appConfig.serviceUrls.saveStateImageEntries,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: AdminEntry[] = await response.json();

      setDataList(data || []);
      setFilteredDataList(data || []);
      //setDataList(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      //setDataList([]);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    //Reset Form
    setFormData({
      id: dataList.length + 1, //Increment ID
      state: "",
      stateName: "",
      imagename: "",
      imageUrls: [],
      isActive: false,
      isIconActive: false,
      status: "",
    });
    setEditingIndex(null);
  };
  //Add New Record
  const handleAdd = () => {
    setEditingIndex(null);
    setShowForm(true);
    // resetForm();// Clear form and show it
    setFormData({
      id: 0,
      state: "",
      stateName: "",
      imagename: "",
      imageUrls: [],
      isActive: false,
      isIconActive: false,

      status: "",
    });
  };

  const handleEdit = (id: number) => {
    if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
      console.error("Error: dataList is empty");
      return;
    }
    const selectedEntry = dataList.find((item) => item.id === id);

    if (!selectedEntry) {
      console.error("No entry found at index:", id);
      return;
    }

    setFormData({
      ...selectedEntry,
      imageUrls:
        typeof selectedEntry.imageUrls === "string"
          ? selectedEntry.imageUrls.split(",")
          : Array.isArray(selectedEntry.imageUrls)
            ? selectedEntry.imageUrls
            : [],
    });
    setEditingIndex(selectedEntry.id);
    setShowForm(true);
  };
  //Delete a record
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure want to delete this entry?")) return;
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(
        `${appConfig.serviceUrls.saveStateImageEntries}/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to delete");

      fetchData();
      if (editingIndex !== null && dataList[editingIndex]?.id === id) {
        setEditingIndex(null);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="container-wraper">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "5px",
        }}
      >
        <Typography className="bold-header-text">
          <b>State Image Management</b>{" "}
        </Typography>
        <Button onClick={handleAdd} size="small" className="custom-button">
          <img src={add} alt="visiable" className="img-style" />{" "}
          <Typography className="btn-text">Add</Typography>
        </Button>
      </Box>
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <TextField
          select
          label="Search by State"
          size="small"
          value={statefilter}
          onChange={(e) => setstatefilter(e.target.value)}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">All State</MenuItem>
          {states.map((st: State) => (
            <MenuItem key={st.id} value={st.name}>
              {st.name}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
        {loading ? (
          <>
            {" "}
            <Spinner></Spinner>
          </>
        ) : (
          <TableContainer
            component={Paper}
            sx={{ padding: 0, width: "100%", maxHeight: "80vh" }}
          >
            {Object.keys(groupedByState).length > 0 ? (
              <>
                {(() => {
                  // Sort the state names alphabetically
                  const sortedStateKeys = Object.keys(groupedByState).sort(
                    (a, b) => a.localeCompare(b),
                  );

                  // Paginate the sorted state keys
                  const paginatedStates = sortedStateKeys.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
                  );

                  return (
                    <>
                      {paginatedStates.map((state) => {
                        const entries = groupedByState[state];

                        return (
                          <Accordion
                            key={state}
                            expanded={expandedState === state}
                            onChange={() =>
                              setExpandedState(
                                expandedState === state ? false : state,
                              )
                            }
                            sx={{ marginBottom: 0 }}
                          >
                            <AccordionSummary
                              expandIcon={
                                <img
                                  src={
                                    expandedState === state
                                      ? minusaccor
                                      : plusaccor
                                  }
                                  alt="toggle"
                                  style={{ width: 20, height: 20 }}
                                />
                              }
                            >
                              <Typography
                                sx={{ fontWeight: "bold", fontSize: "15px" }}
                              >
                                {state}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Table size="medium">
                                <TableHead>
                                  <TableRow className="custom-table-head-row">
                                    <TableCell>
                                      <b>Name</b>
                                    </TableCell>
                                    <TableCell>
                                      <b>Image</b>
                                    </TableCell>
                                    <TableCell>
                                      <b>Active / Disable</b>
                                    </TableCell>
                                    <TableCell>
                                      <b>Set Icon</b>
                                    </TableCell>
                                    <TableCell>
                                      <b>Status</b>
                                    </TableCell>
                                    <TableCell>
                                      <b>Actions</b>
                                    </TableCell>
                                    {/* set Icon */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {entries.map((item) => (
                                    <TableRow key={item.id}>
                                      <TableCell>
                                        {item.imagename || "\u00A0"}
                                      </TableCell>

                                      <TableCell>
                                        {typeof item.imageUrls === "string" &&
                                        item.imageUrls.trim() !== "" ? (
                                          <Box
                                            className="description-wraper"
                                            onClick={() => handleEdit(item.id)}
                                          >
                                            <Typography className="description-txt">
                                              View
                                            </Typography>

                                            {item.imageUrls
                                              .split(",")
                                              .map(
                                                (
                                                  pdf: string,
                                                  index: number,
                                                ) => (
                                                  <div key={index}>
                                                    {/* <a
                                                      href={pdf}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    > */}
                                                    <IconButton
                                                      color="primary"
                                                      size="small"
                                                    >
                                                      <img
                                                        src={visiable}
                                                        alt="visible"
                                                        className="img-style"
                                                      />
                                                    </IconButton>
                                                    {/* </a> */}
                                                  </div>
                                                ),
                                              )}
                                          </Box>
                                        ) : (
                                          <Typography>No Image</Typography>
                                        )}
                                      </TableCell>

                                      <TableCell className="nowrap">
                                        <Box className="status-wrapper">
                                          <Box
                                            className={`status-toggle1 ${
                                              item.isActive
                                                ? "active"
                                                : "Disable"
                                            }`}
                                          >
                                            <Box className="status-circle" />
                                          </Box>

                                          <Typography
                                            className="active-txt"
                                            component="span"
                                          >
                                            {item.isActive
                                              ? "Active"
                                              : "Disable"}
                                          </Typography>
                                        </Box>
                                      </TableCell>

                                      {/* set Icon */}
                                      <TableCell className="nowrap">
                                        <Box className="status-wrapper">
                                          <Box
                                            className={`status-toggle1 ${
                                              item.isIconActive
                                                ? "active"
                                                : "Disable"
                                            }`}
                                          >
                                            <Box className="status-circle" />
                                          </Box>

                                          <Typography
                                            className="active-txt"
                                            component="span"
                                          >
                                            {item.isIconActive
                                              ? "Active"
                                              : "Disable"}
                                          </Typography>
                                        </Box>
                                      </TableCell>

                                      {item.status === "Approved" ? (
                                        <TableCell className="approved-text">
                                          {item.status}
                                        </TableCell>
                                      ) : item.status === "Published" ? (
                                        <TableCell className="approved-text">
                                          {item.status}
                                        </TableCell>
                                      ) : item.status === "Pending" ? (
                                        <TableCell className="pending-txt">
                                          {item.status}
                                        </TableCell>
                                      ) : (
                                        <TableCell className="publish-txt">
                                          {item.status}
                                        </TableCell>
                                      )}
                                      <TableCell
                                        align="left"
                                        className="nowrap sticky-right-top"
                                      >
                                        <IconButton
                                          color="primary"
                                          size="small"
                                          className="Icon-button"
                                          onClick={() => handleEdit(item.id)}
                                        >
                                          <img
                                            src={edit}
                                            alt="edit"
                                            className="img-style"
                                          />
                                        </IconButton>

                                        {role === "System Admin" && (
                                          <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() =>
                                              handleDelete(item.id)
                                            }
                                          >
                                            <img
                                              src={delete1}
                                              alt="delete"
                                              className="img-style"
                                            />
                                          </IconButton>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}

                      {/* Pagination at the bottom */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "1rem",
                          // position: "absolute",
                          bottom: 0,
                          // backgroundColor: "#fff",
                          zIndex: 1,
                          // borderTop: "1px solid #ccc",
                          overflowX: "hidden",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#000",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                          }}
                        >
                          Showing {page * rowsPerPage + 1} to{" "}
                          {Math.min(
                            Object.keys(groupedByState).length,
                            page * rowsPerPage + rowsPerPage,
                          )}{" "}
                          of {Object.keys(groupedByState).length} entries
                        </Typography>

                        <Pagination
                          count={Math.ceil(
                            Object.keys(groupedByState).length / rowsPerPage,
                          )}
                          page={page + 1}
                          onChange={(e, value) => setPage(value - 1)}
                          color="primary"
                          variant="outlined"
                          shape="rounded"
                        />
                      </Box>
                    </>
                  );
                })()}
              </>
            ) : (
              <Box textAlign="center" mt={2}>
                <Typography align="center" sx={{ mt: 2 }}>
                  No records found.
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={handleAdd}
                >
                  <Add fontSize="small" />
                </Button>
              </Box>
            )}
          </TableContainer>
        )}
      </Box>
      <StateImageFormDialog
        open={showForm}
        onClose={() => setShowForm(false)}
        fetchData={fetchData}
        resetForm={resetForm}
        formData={formData}
        setFormData={setFormData}
        editingIndex={editingIndex}
        setShowForm={setShowForm}
        setEditingIndex={setEditingIndex}
        states={states}
        dataList={dataList}
      />
    </Box>
  );
};

export default StateImage;
